import Vue from 'vue'
import regInput from './reg-input'

Vue.directive('reg-input', regInput)



// WEBPACK FOOTER //
// ./src/directives/index.js